// src/notifications/NotistackBridge.tsx
import { useEffect } from "react";
import { useSnackbar } from "notistack";

export const NotistackBridge = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    // expose them globally so non-React code (like refine notification) can use
    (window as any).__enqueueSnackbar = enqueueSnackbar;
    (window as any).__closeSnackbar = closeSnackbar;
  }, [enqueueSnackbar, closeSnackbar]);

  return null;
};
